"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelocatePoleToolController = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const location_input_state_1 = require("../../../components/input/location.input.state");
const theme_1 = require("../../../components/theme");
const point_collection_cache_1 = require("../../topological.editor.map/point.collection.cache");
const topological_editor_tool_abstract_ctrl_1 = require("../topological.editor.tool.abstract.ctrl");
const CSS = {
    withRelocationTool: 'c-PoleRelocationTool__attached',
};
const Style = {
    [CSS.withRelocationTool]: {
        cursor: 'crosshair',
    },
};
(0, theme_1.addStyles)(Style);
class RelocatePoleToolController extends topological_editor_tool_abstract_ctrl_1.TopologicalEditorToolController {
    constructor(ctrl) {
        super(ctrl);
        this.ctrl = ctrl;
        const editCtrl = ctrl.selectedCollectionEdit;
        this.locationField = editCtrl.collectionEditState.collection.editableLocationField;
        ctrl.classnames.push(CSS.withRelocationTool);
        ctrl.map.map.setOptions({ draggableCursor: 'crosshair' });
        this.makeInputState();
        this.bindMapClickEvent();
    }
    makeInputState() {
        let inputState = this.ctrl.selectedCollectionEdit.changeState.getState(this.locationField.id);
        if (!inputState) {
            inputState = new location_input_state_1.LocationInputState(this.locationField.schema.displayName);
            inputState.onValue(() => {
                this.locationField.Mutator.edited(inputState.value);
            });
            this.topologicalEditorController.selectedCollectionEdit.changeState.addState(this.locationField.id, inputState);
            inputState.setValue(this.locationField.value);
        }
        this.inputState = inputState;
    }
    bindMapClickEvent() {
        this.clickEventListener = this.ctrl.map.map.addListener('click', (event) => {
            const { lat, lng } = event.latLng;
            const newLat = lat().toFixed(7);
            const newLng = lng().toFixed(7);
            this.inputState.latitude.setInputValue(newLat);
            this.inputState.longitude.setInputValue(newLng);
            // Next we want to update all the the other spans that are linked to this collection.
            const spans = [];
            // Loop though all the collections on screen.
            for (const collection of this.ctrl.collectionModels) {
                const collectionLinkIds = [];
                // Find all linked spans (including unsaved ones)
                collection.forEachField((field) => {
                    if (core_shared_1.CollectionModelFieldVector.isVectorField(field) &&
                        field.isCollectionLink() &&
                        field.getCollections()[0].revision === this.ctrl.selectedCollection.revision) {
                        collectionLinkIds.push(field.stateValue.collectionId);
                    }
                });
                // If a collection contains a link to the collection that we are moving, then...
                if (collectionLinkIds.includes(this.ctrl.selectedCollection.id)) {
                    // Filter out non spans & spans that are only linked to this collection
                    const vectors = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionVectors(collection.revision);
                    spans.push(...vectors.filter((x) => x.field.id.includes('spanLength') &&
                        x.field.isCollectionLink() &&
                        x.field.getCollections()[0].revision === this.ctrl.selectedCollection.revision));
                }
            }
            for (const span of spans) {
                span.target.latitude = newLat;
                span.target.longitude = newLng;
            }
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionLocations(this.locationField.collection.revision);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.ctrl.updateSpansDistanceBearing(this.locationField.collection.revision);
            this.ctrl.exitTool();
        });
    }
    destroy() {
        this.topologicalEditorController.classnames.filter((x) => x !== CSS.withRelocationTool);
        this.topologicalEditorController.map.map.setOptions({
            draggableCursor: '',
        });
        google.maps.event.removeListener(this.clickEventListener);
    }
}
exports.RelocatePoleToolController = RelocatePoleToolController;
//# sourceMappingURL=relocate.pole.js.map